<section class="panel p-4">
  <div class="d-flex flex-wrap gap-3 align-items-end justify-content-between mb-3">
    <div>
      <h2 class="h5 mb-1">{{ titulo }}</h2>
      <div class="text-secondary small" *ngIf="tipo === 'ajustes'">
        O deferimento grava o horario informado na tabela oficial de marcacoes.
      </div>
      <div class="text-secondary small" *ngIf="tipo === 'ferias'">
        Solicite pelo servidor quando ele não usa o portal. O deferimento abre a portaria, reserva o número oficial e permite exportar o Word (.doc).
      </div>
    </div>
    <div class="d-flex flex-wrap gap-2">
      <button
        *ngIf="tipo === 'ferias'"
        type="button"
        class="btn btn-success"
        [disabled]="!empregadorSelecionado"
        (click)="abrirPedidoFerias()">
        Solicitar férias
      </button>
      <select class="form-select" *ngIf="empregadores.length > 1" [ngModel]="empregadorSelecionado" (ngModelChange)="alterarEmpregador($event)">
        <option value="">Empregador</option>
        <option *ngFor="let empregador of empregadores" [value]="empregador.id">{{ empregador.razaoSocial }}</option>
      </select>
      <select class="form-select" [(ngModel)]="status" (ngModelChange)="recarregar()">
        <option value="PENDENTE">Pendentes</option>
        <option value="DEFERIDA">Deferidas</option>
        <option value="INDEFERIDA">Indeferidas</option>
      </select>
    </div>
  </div>

  <div class="mb-3" *ngIf="status === 'PENDENTE' && tipo === 'ajustes'">
    <label class="form-label" for="parecerSolicitacao">Parecer</label>
    <input class="form-control" id="parecerSolicitacao" type="text" [(ngModel)]="parecer" maxlength="200" placeholder="Opcional">
  </div>

  <div class="table-responsive" *ngIf="tipo === 'ajustes'">
    <table class="table table-sm align-middle" *ngIf="ajustes.length; else vazio">
      <thead>
        <tr>
          <th>Servidor</th>
          <th>Dia</th>
          <th>Horario</th>
          <th>Batida</th>
          <th>Motivo</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of ajustes">
          <td>{{ item.matricula }} - {{ item.nome }}</td>
          <td>{{ item.data }}</td>
          <td>{{ item.hora }}</td>
          <td>{{ item.numeroBatida }}</td>
          <td>{{ item.motivo }}</td>
          <td>{{ rotuloStatus(item.status) }}</td>
          <td class="text-end" *ngIf="item.status === 'PENDENTE'">
            <button type="button" class="btn btn-success btn-sm me-1" (click)="decidirAjuste(item, true)">Deferir</button>
            <button type="button" class="btn btn-outline-danger btn-sm" (click)="decidirAjuste(item, false)">Indeferir</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="table-responsive" *ngIf="tipo === 'ferias'">
    <table class="table table-sm align-middle" *ngIf="ferias.length; else vazio">
      <thead>
        <tr>
          <th>Protocolo</th>
          <th>Servidor</th>
          <th>Periodo</th>
          <th>Solicitado por</th>
          <th>Portaria</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of ferias">
          <td>{{ item.protocolo }}</td>
          <td>{{ item.matricula }} - {{ item.nome }}</td>
          <td>{{ formatarData(item.dataInicioPortaria || item.dataInicio) }} a {{ formatarData(item.dataFimPortaria || item.dataFim) }}</td>
          <td>{{ rotuloOrigem(item) }}</td>
          <td>{{ item.portariaNumero ? item.portariaNumero + '/' + item.portariaAno : '-' }}</td>
          <td>{{ rotuloStatus(item.status) }}</td>
          <td class="text-end">
            <ng-container *ngIf="item.status === 'PENDENTE'">
              <button type="button" class="btn btn-success btn-sm me-1" (click)="decidirFerias(item, true)">Deferir</button>
              <button type="button" class="btn btn-outline-danger btn-sm" (click)="decidirFerias(item, false)">Indeferir</button>
            </ng-container>
            <button
              *ngIf="servicoPortaria.temPortaria(item)"
              type="button"
              class="btn btn-outline-primary btn-sm"
              (click)="exportarPortaria(item)">
              Exportar .doc
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #vazio>
    <p class="text-secondary mb-0">Nenhuma solicitacao neste filtro.</p>
  </ng-template>
</section>

<app-modal-solicitacao-ferias
  [aberta]="modalPedidoAberta"
  [salvando]="salvandoPedido"
  [funcionarios]="funcionarios"
  (fechar)="fecharPedidoFerias()"
  (salvar)="enviarPedidoFerias($event)">
</app-modal-solicitacao-ferias>

<app-modal-portaria-ferias
  [aberta]="modalAberta"
  [salvando]="salvandoPortaria"
  [solicitacao]="solicitacaoPortaria"
  [secretarias]="secretarias"
  [secretarios]="secretarios"
  [parecer]="parecer"
  (parecerChange)="parecer = $event"
  (fechar)="fecharModalPortaria()"
  (salvar)="salvarPortaria($event)"
  (exportar)="exportarPortaria($event)">
</app-modal-portaria-ferias>
